


















































































































































































































































































































































import { Component, Mixins } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import AuthModule from '@/store/modules/Auth';
import GeneralModule from '@/store/modules/General';
import Table from '@/components/Table/Index.vue';
import Breadcrumb from '@/components/Breadcrumb.vue';
import Pagination from '@/components/Pagination.vue';
import DownlineBody from '@/components/Table/DownlineBody.vue';
import DownlineHistoryBody from '@/components/Table/DownlineHistoryBody.vue';
import ManageMixin from '@/mixins/Manage.vue';
import ErrorHandleMixin from '@/mixins/ErrorHandle.vue';
import UserData from '@/data/User';
import utils from '@/services/utils';

@Component({
  components: {
    Table,
    Breadcrumb,
    Pagination,
    DownlineBody,
    DownlineHistoryBody,
  },
  mixins: [ManageMixin],
})
export default class Downline extends Mixins(ManageMixin, ErrorHandleMixin) {
  AuthInstance = getModule(AuthModule, this.$store);

  GeneralInstance = getModule(GeneralModule, this.$store);

  historyPage = 1;

  userId = this.AuthInstance.user._id;

  username = this.AuthInstance.user.username;

  source = this.AuthInstance.user.source;

  searchUsername = '';

  role = 'All';

  startCount = 1;

  utilsInstance = utils;

  PaginationDetail = {
    page: 1,
    amount: 0,
    limit: 100,
  }

  BreadcrumbDefault = [
    {
      username: this.AuthInstance.user.username,
      userId: this.AuthInstance.user._id,
      source: this.AuthInstance.user.source,
    },
  ];

  BreadcrumbList: any = [];

  TableHeadTran = UserData.TableHeadTran;

  historyData = [];

  checkRole = utils.getUserPersistent().user.userPermission.member === 'edit';

  isAdmin = ['ADMIN', 'SUPERADMIN'].includes(this.AuthInstance.user.role);

  header: any = [];

  async created() {
    this.fetchUsers();
    this.initail();
  }

  initail() {
    if (!['SUPERADMIN', 'ADMIN'].includes(this.AuthInstance.user.role)) {
      const header = this.checkRole
        ? UserData.TableHeadDownLine[0].filter((v) => v.displayName !== 'account.downline.edit_pt')
        : UserData.TableHeadDownLineCheckRole[0].filter((v) => v.displayName !== 'account.downline.edit_pt');
      this.header = [header];
    } else {
      this.header = this.checkRole
        ? UserData.TableHeadDownLine
        : UserData.TableHeadDownLineCheckRole;
    }
  }

  submit() {
    this.PaginationDetail.page = 1;
    this.fetchUsers();
  }

  async fetchUsers() {
    const {
      PaginationDetail: {
        page,
        limit,
      },
      searchUsername,
      BreadcrumbDefault,
      role,
      username,
      source,
    } = this;
    let res;
    this.GeneralInstance.toggleLoading(true);
    if (searchUsername) {
      this.role = 'All';
      res = await this.AccountInstance.FetchDownLineSearch({
        username: searchUsername.trim(),
      });
    } else {
      res = await this.AccountInstance.FetchDownLine({
        pageOption: {
          page,
          limit,
        },
        userId: this.userId ? this.userId : this.AccountInstance.users._id,
        role,
        username,
        source,
      });
    }
    this.GeneralInstance.toggleLoading(false);
    if (res.code) {
      this.checkError(res);
    } else {
      const { users, pagination, breadcrumb } = this.AccountInstance.users;
      this.startCount = pagination ? pagination.startCount : 1;
      this.userList = users ? [...users] : [];
      this.PaginationDetail.amount = pagination
        ? pagination.pageAmount
        : 0;
      this.BreadcrumbList = [...BreadcrumbDefault, ...breadcrumb];
    }
    if (this.BreadcrumbList.length > 1 && !this.isAdmin) {
      this.header = UserData.TableHeadParent;
    } else if (this.isAdmin) {
      this.header = this.checkRole
        ? UserData.TableHeadDownLine
        : UserData.TableHeadDownLineCheckRole;
    } else {
      this.initail();
    }
  }

  changePage(i) {
    this.PaginationDetail.page = i;
    this.fetchUsers();
  }

  async report(user) {
    this.historyPage = 1;
    this.currentSelectUser = user._id;
    this.GeneralInstance.toggleLoading(true);
    const res = await this.AccountInstance.FetchHistory({ userId: this.currentSelectUser });
    this.GeneralInstance.toggleLoading(false);
    if (res.code) {
      this.checkError(res);
    } else {
      this.pageRenderHistory();
      this.modal.report = true;
    }
  }

  pageRenderHistory() {
    this.historyData = this.AccountInstance.history
      .slice((this.historyPage - 1) * 5, (this.historyPage * 5));
  }

  handlePage(param) {
    this.historyPage += param;
    this.pageRenderHistory();
  }

  editPT(user) {
    this.currentSelectUser = user._id;
    this.modal.pt = true;
  }

  async submitEditPT() {
    const params = {
      userId: this.currentSelectUser,
      general: this.modalData.pt.general / 100,
      pg: this.modalData.pt.general / 100,
      ds: this.modalData.pt.general / 100,
    };
    const res = await this.AccountInstance.UpdateCommission(params);
    this.alert(res);
  }

  alert(res) {
    const { code } = res;
    if (code === 0) {
      this.modalData = {
        profile: UserData.initialUserInfo(),
        lock: UserData.initialLock(),
        password: UserData.initialPassword(),
        pt: UserData.initialPT(),
        refill: UserData.initialRefill(),
        deduct: UserData.initialDeduct(),
      };
    }
    this.modal = UserData.initialModal();
    this.checkError(res);
    this.fetchUsers();
  }

  async handleSub(user) {
    this.prepareFetch(user);
  }

  async handleBreadcrumb(user) {
    this.prepareFetch(user);
  }

  handleLevel() {
    this.PaginationDetail.page = 1;
    this.fetchUsers();
  }

  prepareFetch(user) {
    this.userId = user._id || user.userId;
    this.username = user.username;
    this.source = user.source;
    this.PaginationDetail.page = 1;
    this.searchUsername = '';
    this.fetchUsers();
  }
}
